module.exports = __webpack_public_path__ + "img/special-event_cn.808128f.jpg";